import React, { useState, useEffect } from 'react';
import image from '../assets/images/crueltysquad-cruelty-squad.gif';
import { Link } from 'react-router-dom';
import loadingGif from '../assets/images/eye.gif';

const Home = () => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 2500);

        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <img src={loadingGif} alt="Loading..." className="w-32 h-32" />
            </div>
        )
    }

    return (
            <div className="flex items-center justify-center px-6 pt-2 lg:px-8 min-h-screen">
                <div className="mx-auto max-w-2xl py-24 sm:py-24 lg:py-24">
                    <div className="text-center">
                        <img src={image} alt="LIFE" className="mx-auto w-48 h-auto pb-8" />
                        <h1 className="text-5xl font-semibold tracking-tight sm:text-7xl">Fintan Gallagher: Portfolio</h1>
                        <p className="mt-8 text-lg font-medium sm:text-2xl">Learning Computers to Pay for Failing Music Career</p>
                        <div className="mt-10 flex items-center justify-center gap-x-6">
                        <Link to="/about" className="text-sm font-semibold">Enter <span aria-hidden="true">→</span></Link>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Home;